import { render, staticRenderFns } from "./ContactReportPage.vue?vue&type=template&id=5a196e42&"
import script from "./ContactReportPage.vue?vue&type=script&lang=js&"
export * from "./ContactReportPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactReportPage.vue?vue&type=style&index=0&id=5a196e42&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports